import { useTranslation } from '@supply-mover-2-0/web-ui';
import type { JSX } from 'react';
import { CatalogBrowser } from '../../catalog/CatalogBrowser';

/**
 * Catalog widget (PD-14547) — embeds the FULL catalog experience
 * (category sidebar, faceted filters, sort, grid/list toggle,
 * pagination) on the storefront homepage, so admins can compose a
 * shop page with promo/content widgets above or below the catalog.
 *
 * The browser keeps its URL-query-param state model, so deep links
 * and back/forward work exactly like /catalog. Consequence: place at
 * most ONE Catalog widget per design (two instances would read and
 * write the same params) — the registry description says so too.
 *
 * Best placed full-width; the storefront layout's content-driven rows
 * let it grow to whatever height the current page of results needs.
 */
export function CatalogWidget({ title }: { title?: string }): JSX.Element {
	const { t } = useTranslation();
	return (
		<section className="w-full h-full flex flex-col">
			{title != null && title.trim().length > 0 && (
				<header className="mb-3">
					<h2 className="text-base md:text-lg font-semibold text-gray-900 dark:text-gray-100">
						{t(title)}
					</h2>
				</header>
			)}
			<CatalogBrowser embedded />
		</section>
	);
}
